import { render, staticRenderFns } from "./AddEditCard.vue?vue&type=template&id=54755a44&scoped=true&"
import script from "./AddEditCard.vue?vue&type=script&lang=js&"
export * from "./AddEditCard.vue?vue&type=script&lang=js&"
import style0 from "./AddEditCard.vue?vue&type=style&index=0&id=54755a44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54755a44",
  null
  
)

export default component.exports